var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarFullWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00822 3.69098C9.30757 2.76967 10.611 2.76967 10.9103 3.69098L11.8676 6.63729C12.0015 7.04931 12.3855 7.32827 12.8187 7.32827H15.9166C16.8854 7.32827 17.2881 8.56789 16.5044 9.13729L13.9981 10.9582C13.6476 11.2128 13.501 11.6642 13.6349 12.0762L14.5922 15.0225C14.8915 15.9439 13.837 16.71 13.0533 16.1406L10.5471 14.3197C10.1966 14.065 9.72197 14.065 9.37149 14.3197L6.86521 16.1406C6.08149 16.71 5.02702 15.9439 5.32637 15.0225L6.28368 12.0762C6.41756 11.6642 6.2709 11.2128 5.92041 10.9582L3.41413 9.13729C2.63042 8.56789 3.0332 7.32827 4.00192 7.32827H7.09985C7.53307 7.32827 7.91703 7.04931 8.0509 6.63729L9.00822 3.69098Z",
    fill: "#FFFFFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFullWhite);
export default __webpack_public_path__ + "static/media/star-full-white.e43cae5e572c076adfb54763e251ab87.svg";
export { ForwardRef as ReactComponent };